/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DisplayMode {
    Auto = 0,
    Default = 1,
    AxisMediaStreamLibrary = 6,
    None = 9,
    RtspWebRtc = 11,
}
